import { render, staticRenderFns } from "./SectionHot.vue?vue&type=template&id=0edb208e&scoped=true"
import script from "./SectionHot.vue?vue&type=script&lang=js"
export * from "./SectionHot.vue?vue&type=script&lang=js"
import style0 from "./SectionHot.vue?vue&type=style&index=0&id=0edb208e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb208e",
  null
  
)

export default component.exports